import React from "react"

export const ZoomImageIcon = ({ size = 1, color = "#034055" }) => {
  return (
    <svg
      width={size * 80}
      height={size * 80}
      viewBox="0 0 80 80"
      className="zoom-image-icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        fillOpacity="0.8"
        cx="40"
        cy="40"
        r="40"
      />
      <path
        id="pointer-up"
        fill={color}
        d="M53.5,42.1h-3V30.5H39v-3h14.5V42.1z"
      />
      <path
        id="pointer-down"
        fill={color}
        d="M41,54.6H26.5V40h3v11.6H41V54.6z"
      />
    </svg>
  )
}
